import React from "react"
import { Row, Col, Dropdown } from "react-bootstrap"
import { selectDocument } from "../../redux/actions"
import { useDispatch } from "react-redux"
import Dropzone from "../dropzone"
import * as Constants from "../../common/constants"

const RequiredDocuments = ({ uiData }) => {
  const {
    proofDocuments,
    claimUploadListModel,
    pageNumber,
    hideHeaderFooter,
    lockUploadDropdown,
  } = uiData

  const previewsContainer = "BasicDocumentPreview"
  const dispatch = useDispatch()

  function DropdownValueChange(documentId, documentDesc) {
    dispatch(selectDocument(documentId, documentDesc))
  }

  function checkDocumentStatus(documentId) {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })

    return hasExists.length > 0
  }

  const countUploadedDocument = () => {
    if (pageNumber === Constants.policyInfoPageNumber) {
      return false
    } else {
      return true
    }

    // return (
    //   claimUploadList.length > 0 ||
    //   tempBenefitInfo.CoverageCode === coverageCode ||
    //   tempBenefitInfo.CoverageDetailId === coverageDetailId ||
    //   coverageDetailId === Constants.basicCoverageDetailId
    // )
  }

  const createCovidDocumentsList = () => {
    let covidDocumentsArray = []
    proofDocuments.map((item, key) => {
      covidDocumentsArray.push(
        <Row
          key={key}
          className="mt-3 paddingLeft15px paddingRight15 unsetMarginTopBottom"
        >
          <Col
            xs={12}
            md={12}
            className={
              "marginTop10px CheckBox documentUpload" +
              (checkDocumentStatus(item.documentId)
                ? " documentSelectedText"
                : "")
            }
          >
            <div>
              {item.description +
                " " +
                (item.mandatory ? "Required" : "")}
            </div>
          </Col>
        </Row>
      )

      return null
    })
    return covidDocumentsArray
  }

  const createCovidDocumentsDropdownList = () => {
    let covidDocumentsDropdownArray = []
    proofDocuments.map((item, key) => {
      covidDocumentsDropdownArray.push(
        <Dropdown.Item
          key={key}
          onClick={DropdownValueChange.bind(
            this,
            item.documentId,
            item.description
          )}
          className={
            "dropdown-item DropdownItem AddTripDocumentClass " +
            (lockUploadDropdown ? "disabled" : "")
          }
        >
          {item.description}
        </Dropdown.Item>
      )

      return null
    })
    return covidDocumentsDropdownArray
  }

  return (
    <>
      <div>
        <Row
          className={
            pageNumber === Constants.requiredDocumentPageNumber ? "" : "hide"
          }
        >
          <div
            className={
              "title text-center " +
              (pageNumber === Constants.requiredDocumentPageNumber
                ? ""
                : "hide") +
              " " +
              (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
            }
          >
            Upload supporting documents
          </div>
          <Row className={"containerBody marginTop3x"}>
            <Col
              xs={{ span: 12, offset: 0 }}
              md={{ span: 12, offset: 0 }}
              className="formContainer"
            >
              <div
                className={
                  "horizontal-align marginBottom1x " +
                  (pageNumber === Constants.requiredDocumentPageNumber
                    ? ""
                    : "hide")
                }
              >
                <Col xs={12} md={12}>
                  <div
                    className={
                      "titleText " +
                      (pageNumber === Constants.requiredDocumentPageNumber
                        ? "hide"
                        : "")
                    }
                  >
                    Claim documents
                  </div>
                </Col>
              </div>
              <div className="formNoteSection marginBottom19px">
                <span className="highlight-text">PLEASE NOTE:</span> Etiqa’s 
                Representatives may contact you and request for certified true 
                copies of your documents for verification purposes.
              </div>
              <Row>
                <p className="DescriptionTxt">
                  Below is a list of supporting documents:
                  <br />
                </p>
              </Row>
              {createCovidDocumentsList()}
              <br />
              <Row>
                <p className="DescriptionTxt">
                  <span className="note-title">NOTE:&nbsp;</span>
                  <span className="note">
                    Please attach address proof in .jpg, .png, .jpeg, .pdf
                    format only, not more than 10MB
                  </span>
                </p>
              </Row>
              <Row className="mt-5 paddingLeft15px paddingRight15">
                <Col xs={12} md={12} className="SupportingDocumentsUploadArea">
                  <div className="mt-2">
                    {countUploadedDocument() && (
                      <>
                        <Row>
                          <p className="DescriptionTxt">Select document name</p>
                          <Dropdown className="dropdown col-10">
                            <Dropdown.Toggle
                              id="dropdown-basic"
                              className="btn btn-secondary dropdown-toggle DropdownHeader"
                            >
                              {uiData.tempSelectedDocument.documentDesc}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu DropdownMenu">
                              {createCovidDocumentsDropdownList()}
                            </Dropdown.Menu>
                          </Dropdown>

                          <Dropzone
                            uiData={uiData}
                            previewsContainer={previewsContainer}
                          />
                        </Row>

                        <Row>
                          <div
                            id={previewsContainer}
                            style={{
                              width: "auto !important",
                              border: "transparent !important",
                              display: "contents",
                            }}
                            className={"dropzone "}
                          ></div>
                        </Row>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Row>
      </div>
    </>
  )
}

export default RequiredDocuments
